import {Injectable} from '@angular/core';
import {ParametersService} from "../parameters.service";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CanvasService {
    canvasObj: HTMLCanvasElement;
    context: CanvasRenderingContext2D;
    canvasJSLoaded = new BehaviorSubject<boolean>(false);
    canvasJSLoaded$ = this.canvasJSLoaded.asObservable();

    constructor(
        private parameters: ParametersService,
    ) {
    }

    loadCanvasJS(): void {
        if(this.canvasJSLoaded.getValue() === false) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '/assets/canvasjs/canvasjs.min.js';
            script.onload = () => {
                this.canvasJSLoaded.next(true);
            }
            document.body.appendChild(script);
        }
    }

    setChartColor(): string {
        if (this.parameters.urlCompany === 'klimor') return '#0061aa'; // $primary

        return "#c5011c";
    }

    drawHashTable(): void {
        for(let i = 0; i<9; i++){
            this.drawHash(30, i * 45+45 , 390, i * 45+45 );
            this.drawHash(i * 45+30, 45, i * 45+30, 405);
        }
        this.context.fillStyle = "rgba(204, 204, 204,0.6)";
        this.context.fillRect(29,44,362,91);
    }

    drawTempAll(): void {
        for(let i = 0; i<8; i++){
            this.drawTemp(0, i * 45 + 45, 80 - (i * 10));
            this.drawTemp(i * 45 + 60, 420, 15 - (i * 5));
        }
    }

    drawPoint(x: number, y: number, value: string): void {
        this.context.beginPath();
        this.context.arc(x, y, 6, 0, 2 * Math.PI, false);
        this.context.fillStyle = "#ffffff";
        this.context.fill();
        this.context.lineWidth = 4;
        this.context.strokeStyle = this.setChartColor();
        this.context.stroke();
        this.context.font = "15px Arial";
        this.context.fillStyle = this.setChartColor();
        if (y > 27) {
            this.context.fillText(value, x - 8, y - 15);
        } else {
            this.context.fillText(value, x - 8, y + 30);
        }
    }

    drawLine(x1: number, y1: number, x2: number, y2: number): void {
        this.context.beginPath();
        this.context.moveTo(x1, y1);
        this.context.lineTo(x2, y2);
        this.context.lineWidth = 4;
        this.context.strokeStyle = this.setChartColor();
        this.context.stroke();
    }

    clear(): void {
        this.context.fillStyle = "#f8f8f8";
        this.context.fillRect(28,0,400,44);
        this.context.fillStyle = "#f8f8f8";
        this.context.fillRect(400,0,400,450);
        this.context.fillStyle = "#f8f8f8";
        this.context.fillRect(0,410,450,450);
    }

    private drawHash(x1: number, y1: number, x2: number, y2: number): void {
        this.context.beginPath();
        this.context.moveTo(x1, y1);
        this.context.lineTo(x2, y2);
        this.context.lineWidth = 1;
        this.context.strokeStyle = "#919191";
        this.context.stroke();
    }

    private drawTemp(x: number, y: number, element: number){
        this.context.font = "11px Arial";
        this.context.fillStyle = '#000';
        this.context.fillText(element+'°C',x,y);
        this.context.fillText(element+'°C',x,y);
    }
}
